
export default function Categories() {
  const categories = [
    {
      icon: "ri-seedling-line",
      title: "Persönliche Entwicklung",
      items: [
        "Depression, Burn-Out, Stress, emotionale Erschöpfung",
        "Motivation, Klarheit, Selbstvertrauen",
        "Ziele setzen & erreichen, Fokus trainieren",
        "Dankbarkeit, Achtsamkeit, Gelassenheit"
      ],
      color: "from-green-400 to-teal-500"
    },
    {
      icon: "ri-briefcase-line",
      title: "Beruf & Erfolg",
      items: [
        "Karriere-Entscheidungen & Selbstorganisation",
        "Work-Life-Balance & Leadership",
        "Konfliktlösung & Kommunikation",
        "Unternehmerische Klarheit & Fokus"
      ],
      color: "from-blue-400 to-indigo-500"
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Finanzen & Freiheit",
      items: [
        "Geldblockaden & Glaubenssätze lösen",
        "Finanzielle Klarheit & Prioritäten",
        "Wohlstandsbewusstsein & langfristige Planung"
      ],
      color: "from-yellow-400 to-orange-500"
    },
    {
      icon: "ri-heart-pulse-line",
      title: "Gesundheit & Fitness",
      items: [
        "Motivation für Training & Ernährung",
        "Gewohnheiten & mentale Disziplin",
        "Mind-Body-Connection & Energieaufbau"
      ],
      color: "from-red-400 to-pink-500"
    },
    {
      icon: "ri-football-line",
      title: "Sport & Performance",
      items: [
        "Mentaltraining für Athleten",
        "Umgang mit Druck & Rückschlägen",
        "Fokus, Routine, Visualisierung",
        "Turniervorbereitung & Siegermentalität"
      ],
      color: "from-purple-400 to-indigo-500"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            In welchen Lebensbereichen Mindshift AI dich unterstützt
          </h2>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${category.color} flex items-center justify-center mb-6`}>
                <i className={`${category.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                {category.title}
              </h3>
              
              <ul className="space-y-3">
                {category.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start">
                    <div className="w-2 h-2 bg-teal-500 rounded-full mr-3 mt-2 flex-shrink-0"></div>
                    <span className="text-gray-600 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
